import axios from 'axios'
// axios.defaults.headers.common['content-type'] = 'application/json';
export default axios.create()
